'use_strict';
// @ts-check
/* global $ module require */

/**
 * Class to retrieve html code for a given newsletter then populate an iframe with that content.
 *
 * @property {string} id of newsletter to get html content for.
 * @property {string} style identifier of whether to get branded or unbranded newsletter html.
 * @property {HTMLElement} iframe container iframe to hold newsletter html content.
 */
class Newsletter {

    id: string;
    style: string;
    iframe: HTMLIFrameElement;

    /**
     * Accepts id of the newsletter to retrieve then fetches the html content for it.
     *
     * @param {string} id from js-newsletter_id
     */
    constructor(id: string) {
        this.id = id;
        this.style = (<HTMLInputElement>document.getElementById('js-newsletter_style')).value;
        this.iframe = <HTMLIFrameElement>document.getElementById('js-newsletter_container');

        this.retrieve_newsletter_html();
    }

    /**
     * Makes the ajax request to get the newsletter html.
     *
     * @private
     * @return {void}
     */
    retrieve_newsletter_html(): void {
        $.ceAjax('request', 'index.php?dispatch=tv_newsletters.newsletter_as_html', {
            method: 'POST',
            data: { id: this.id, style: this.style },
            cache: false,
            callback: this.populate_iframe.bind(this)
        });
    }

    /**
     * Populates the newsletter iframe with newsletter html.
     *
     * @callback
     * @param {Object} data CS Cart ajax response.
     * @returns {void}
     */
    populate_iframe(data): void {
        if (data.json) {
            const iframedoc = this.iframe.contentDocument || this.iframe.contentWindow.document;
            iframedoc.body.innerHTML = data.json.html;
        }
    }
}

/**
 * Looks for the a newsletter id element and if it exists, initializes an instance of the Newsletters.
 *
 * @returns {void}
 */
export function init() {
    const id = <HTMLInputElement>document.getElementById('js-newsletter_id');
    if (id) {
        (() => new Newsletter(id.value))();
    }
}
